import { YEARS_SELECTED } from 'constants/actionTypes';
import { yearsAvailableForAnalysis } from '../../config/staticText.config';

const initialState = {
  start: yearsAvailableForAnalysis[0],
  end: yearsAvailableForAnalysis[yearsAvailableForAnalysis.length - 1]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case YEARS_SELECTED:
      return action.years || initialState;
    default:
      return state;
  }
};
